
const GET_ACCOUNT_BY_QR_CODE_REQUEST = 'Find Account By QR Code'

export {
  GET_ACCOUNT_BY_QR_CODE_REQUEST
}

